import { render, staticRenderFns } from "./RadioKasdaType.vue?vue&type=template&id=58c200b0&lang=pug"
import script from "./RadioKasdaType.vue?vue&type=script&lang=js"
export * from "./RadioKasdaType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports